<template>
  <div class="filter-by-department-tag">
    <Icon name="department_tag_icon" class="filter-by-department-tag__sitemap-icon" />
    <span class="filter-by-department-tag__name">{{ departmentName }}</span>

    <button
      class="filter-by-department-tag__scope-pill"
      type="button"
      :aria-label="`Scope: ${scopeLabel}. Click to toggle.`"
      @click="emit('toggle-scope')"
    >
      <Icon v-if="scope === 'with-sub-depts'" name="mini_department_tag_icon" />
      <span class="filter-by-department-tag__scope-label">{{ scopeLabel }}</span>
    </button>

    <button
      class="filter-by-department-tag__clear"
      type="button"
      aria-label="Clear department filter"
      @click="emit('clear')"
    >
      <Icon name="popup_close" />
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import Icon from "@components/icons/Icon.vue";

const props = defineProps({
  departmentName: {
    type: String,
    required: true,
  },
  breadcrumb: {
    type: String,
    default: "",
  },
  scope: {
    type: String,
    default: "with-sub-depts",
    validator: (value) => ["with-sub-depts", "direct-only"].includes(value),
  },
});

const emit = defineEmits(["toggle-scope", "clear"]);

const scopeLabel = computed(() =>
  props.scope === "with-sub-depts" ? "+ sub-depts" : "direct only"
);
</script>

<style scoped>
.filter-by-department-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 10px 10px 10px 12px;
  background-color: #f5f3ff;
  border: 1px solid #e9d7fe;
  border-radius: 8px;
  box-sizing: border-box;
}

::v-deep .filter-by-department-tag__sitemap-icon svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

::v-deep .filter-by-department-tag__sitemap-icon svg path {
  stroke: #475467;
}

.filter-by-department-tag__name {
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #101828;
  white-space: nowrap;
  flex-shrink: 0;
}

.filter-by-department-tag__scope-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background-color: #e9d7fe;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
}

.filter-by-department-tag__scope-pill:hover {
  background-color: #d6bbfb;
}

::v-deep .filter-by-department-tag__scope-icon svg {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.filter-by-department-tag__scope-label {
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  color: #6941c6;
  white-space: nowrap;
}

.filter-by-department-tag__clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}

::v-deep .filter-by-department-tag__clear-icon svg {
  width: 20px;
  height: 20px;
}

.filter-by-department-tag__clear:hover ::v-deep svg path {
  stroke: #344054;
}
</style>
